import { render, staticRenderFns } from "./QaQuestionContentQuestion.vue?vue&type=template&id=c3392a40&scoped=true&"
import script from "@/scripts/QA/Question/components/QaQuestionContentQuestion?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/QaQuestionContentQuestion?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3392a40",
  null
  
)

export default component.exports